import { useStageSurface } from 'room/common/stage-surface'

/**
 * Whether the in-person stage is read from the back of the room, and so
 * shows a poll in large type (`PollStageCard`): the projector, and the
 * trainer's own window whenever it is not the console of a running
 * presentation - presented on one screen, or mirrored to a TV. The console
 * keeps the poll's everyday look, which the trainer reads up close.
 */
export const useStageReadByTheRoom = (): boolean =>
	useStageSurface() !== 'console'
